@if(!loading) {
<div class="padding header">
    <div>
        <h1 id="hubReportHeader">{{ 'hubReportV2.hubReport' | transloco }}</h1>
        @if (this.lastUpdatedDate) {
        {{ 'common.labels.updatedOn' | transloco: { date: (this.lastUpdatedDate | localizedDate) } }}
        }
    </div>
    <div>
        @if(isAdmin) {
        <button style="padding: 0px 15px;" (click)="regenerateDocument()" mat-flat-button color="accent"
            [attr.aria-label]="'hubReportV2.regenerateHubReportButton' | transloco" data-testid="regenerate-document-button">
            <mat-icon aria-hidden="false" [attr.aria-label]="'common.labels.downloadIcon' | transloco">autorenew</mat-icon>
            <mat-label>{{ 'hubReportV2.regenerateDocument' | transloco }}</mat-label>
        </button>
        }
        @if(currentRoot?.document) {
        <button style="padding: 0px 15px; margin-left:5px;" (click)="downloadHubReport()" mat-flat-button color="accent"
            [attr.aria-label]="'hubReportV2.downloadHubReportButton' | transloco" data-testid="download-hub-report-button">
            <mat-icon aria-hidden="false" [attr.aria-label]="'common.labels.downloadIcon' | transloco">download</mat-icon>
            <mat-label>{{ 'common.labels.downloadDocument' | transloco }}</mat-label>
        </button>
        }
    </div>
</div>
}

<div class="padding" id="ubo_tree"></div>

@if(!loading) {
<div class="padding">
    <mat-tab-group class="top-level-tab-group" [(selectedIndex)]="tabIndex" (selectedTabChange)="onSelectedTabChange($event)">
        @if (shouldShowOwnershipSummary()) {
        <mat-tab [label]="'hubReportV2.ownershipSummary' | transloco">
            <mat-card class="card-margin">
                <mat-card-content>
                    <span>{{ 'hubReport.totalEffectiveOwnershipOf' | transloco: { name: getNodeLabel(currentRoot) } }}</span>
                    @if (currentRoot?.hasDeclaredNoSignificantShareholders ?? false) {
                    <div class="margin-top-15 margin-bottom-15 text-faded">
                        {{ (currentRoot?.isUnregisteredEntity ? 'hubReportV2.attestorHasDeclaredThatNoTrusteesBeneficiaries' : 'hubReportV2.attestorHasDeclaredThatNoShareholders') | transloco }}
                    </div>
                    } @else if (finalOwnershipRecords?.length === 0) {
                    <div class="margin-top-15 margin-bottom-15 text-faded">
                        {{ 'hubReportV2.noOwnershipProvidedYet' | transloco }}
                    </div>
                    } @else {
                    <div class="margin-top-15 margin-bottom-15">
                        @for(record of finalOwnershipRecords; track record) {
                        <div class="flex-container">
                            @if (record.dateOfBirth) {
                            <div class="flex-item-2">{{ record.name }} ({{ record.dateOfBirth | date: 'yyyy-MM-dd' }}):</div>
                            } @else {
                            <div class="flex-item-2">{{ record.name }}:</div>
                            }
                            <div class="flex-item">{{ record.percentage?.toFixed(2) }}%</div>
                        </div>
                        }
                    </div>
                    }
                    <div>{{ 'hubReportV2.remainingUltimateBeneficialOwnershipPercentage' | transloco }}
                        @if (finalOwnershipRecords?.length === 0) {
                        <span class="bold">100%</span>
                        } @else {
                        <span class="bold">{{ outstandingOwnership?.toFixed(2) }}%</span>
                        }
                    </div>
                    @if ((levels?.length ?? 0) > 0) {
                    <div class="spacer-smaller"></div>
                    @for (level of levels; track level) {
                    @if (level.hasDeclaredNoOtherSignificantShareholders) {
                    <div class="margin-top-5"><span [innerHTML]="(level.isUnregisteredEntity ? 'hubReportV2.declaredNoOtherTrusteesBeneficiaries' : 'hubReportV2.declaredNoOtherShareholders') | transloco"></span> <span class="bold">{{ level.name }}</span></div>
                    } @else if (level.hasDeclaredNoSignificantShareholders) {
                    <div class="margin-top-5"><span [innerHTML]="(level.isUnregisteredEntity ? 'hubReportV2.declaredNoTrusteesBeneficiaries' : 'hubReportV2.declaredNoShareholders') | transloco"></span> <span class="bold">{{ level.name }}</span></div>
                    }
                    }
                    }
                </mat-card-content>
            </mat-card>
        </mat-tab>
        }
        @if (hasPepsAndSanctions) {
        <mat-tab [label]="'hubReportV2.pepsAndSanctions' | transloco">
            <mat-card class="card-margin">
                <mat-card-content>
                    <lib-parties-list [observableParties$]="pepsAndSanctionsParties$" [order]="getPepsAndSanctionsOrder()"
                        [uiConfiguration]="getPepsAndSanctionsPartiesUiConfiguration()"></lib-parties-list>
                </mat-card-content>
            </mat-card>
        </mat-tab>
        }
        @for (tab of tabs; track tab) {
        <mat-tab [label]="tab.label">
            <mat-tab-group class="mid-level-tab-group" (selectedTabChange)="scroll()">
                <mat-tab class="bottom-level">
                    <ng-template mat-tab-label>
                        <div class="flex-container-vertical-center flex-container-space-between">
                            <span class="flex-item">{{ 'common.labels.actions' | transloco }}</span>
                        </div>
                    </ng-template>
                    <mat-card class="card-margin">
                        <mat-card-content>
                            @if(tab.node !== currentRoot) {
                            <div class="margin-bottom-15">{{ tab.label }} {{ 'hubReport.owns' | transloco }} <span class="bold">{{
                                    tab.node.ownershipPercentageOfRoot?.toFixed(2) }}%</span> {{ 'hubReport.of' | transloco }}
                                @if (tab.node.party.partyTypeID === 'IndividualShareholder') {
                                {{ getNodeLabel(currentRoot, false, false, true) }}.
                                } @else {
                                {{ getNodeLabel(tab.node.parent, false, false, true) }}.
                                }</div>
                            }
                            @if (tab.node.isUnregisteredEntity) {
                            <div class="flex-container-vertical-center margin-bottom-15"><mat-icon class="icon-info margin-right-15">info</mat-icon> <span>{{ (isFinancialInstitution(tab) ? 'hubReportV2.financialInstitutionsAreUnregistered' : 'hubReportV2.theAttestorClaimedThatThisEntity') | transloco }}</span></div>
                            }
                            @if (tab.someParentHasIncompleteUBO && !tab.uboOrder) {
                            <div class="flex-container-vertical-center margin-bottom-15"><mat-icon class="icon-info margin-right-15">info</mat-icon> 
                                <span>{{ 'hubReportV2.anEntityFartherUpTheShareholder' | transloco }}</span>
                            </div>
                            }
                            @if (tab.someChildHasUBO && !tab.uboOrder) {
                            <div class="flex-container-vertical-center margin-bottom-15"><mat-icon class="icon-info margin-right-15">info</mat-icon> 
                                <span>{{ 'hubReportV2.aDownstreamEntityInTheShareholder' | transloco }}</span>
                            </div>
                            }
                            <div class="margin-bottom-15">{{ (tab.node.isUnregisteredEntity ? 'hubReportV2.actionsForUnregisteredBusiness' : 'hubReportV2.actionsForBusiness') | transloco: { type: getTypeLabel(tab.node) } }}</div>
                            @if (tab.node !== currentRoot && !tab.node.isUnregisteredEntity) {
                                @if (tab.businessSearchOrder) {
                                    @if (!tab.businessReportOrder) {
                                    <div class="flex-container-vertical-center"><mat-icon class="icon-info margin-right-15">info</mat-icon> <span>
                                        {{ 'hubReportV2.youMayNotOrderABusiness' | transloco }}</span></div>
                                    }
                                } @else {
                                    @if (!tab.node.isValidated) {
                                        @if(!tab.businessReportOrder) {
                                        <div class="flex-container-vertical-center"><mat-icon class="icon-warning margin-right-15">warning</mat-icon> <span [innerHTML]="'hubReportV2.attestorDidNotValidate' | transloco"></span></div>
                                        }
                                    } @else if(!tab.businessReportOrder) {
                                    <div class="flex-container-vertical-center"><mat-icon class="icon-info margin-right-15">info</mat-icon> <span [innerHTML]="'hubReportV2.attestorDidValidate' | transloco"></span></div>
                                    }
                                }
                            }
                            <mat-list>
                                @if(tab.node !== currentRoot && !tab.node.isUnregisteredEntity) {
                                <mat-list-item>
                                    <mat-icon matListItemIcon>search</mat-icon>
                                    <div matListItemTitle>
                                        @if (!tab.businessSearchOrder) {
                                        <button (click)="orderBusinessSearch(tab)" mat-flat-button color="accent"
                                            [attr.aria-label]="'hubReportV2.orderBusinessSearchButton' | transloco"
                                            data-testid="order-business-search-button"
                                            [disabled]="tab.businessReportOrder || (tab.node.businessCountry !== 'CA' && tab.node.businessCountry !== 'US')">
                                            <mat-label>{{ 'hubReportV2.orderABusinessSearch' | transloco }}</mat-label>
                                        </button>
                                        } @else {
                                        <button mat-flat-button color="accent" (click)="viewOrder(tab.businessSearchOrder.id, false)">{{ 'hubReportV2.goToBusinessSearchOrder' | transloco }}</button>
                                        }
                                    </div>
                                    @if(tab.businessSearchOrder) {
                                    <div matListItemLine class="padding-top-15">
                                        <span>{{ 'common.labels.orderStatus' | transloco }}: <span class="bold">{{
                                                getOrderStatus(tab.businessSearchOrder.orderStatusTypeID) }}</span></span>
                                    </div>
                                    }
                                </mat-list-item>
                                } 
                                @if (!tab.node.isUnregisteredEntity || tab.businessReportOrder) {
                                <mat-list-item>
                                    <mat-icon matListItemIcon>domain</mat-icon>
                                    <div matListItemTitle>
                                        @if(!tab.businessReportOrder) {
                                        <button [disabled]="shouldDisableBusinessReportButton(tab)"
                                            (click)="orderBusinessReport(tab)" mat-flat-button color="accent"
                                            [attr.aria-label]="'hubReportV2.orderBusinessReportButton' | transloco"
                                            data-testid="order-business-report-button">
                                            <mat-label>{{ 'hubReportV2.orderABusinessReport' | transloco }}</mat-label>
                                        </button>
                                        } @else {
                                        <button mat-flat-button color="accent" (click)="viewOrder(tab.businessReportOrder.id, false)">{{ 'hubReportV2.goToBusinessReportOrder' | transloco }}</button>
                                        }
                                    </div>
                                    @if(tab.businessReportOrder) {
                                    <div matListItemLine class="padding-top-15">
                                        <span>{{ 'common.labels.orderStatus' | transloco }}: <span class="bold">{{
                                                getOrderStatus(tab.businessReportOrder.orderStatusTypeID) }}</span></span>
                                    </div>
                                    }
                                </mat-list-item>
                                }
                                <mat-list-item>
                                    <mat-icon matListItemIcon>groups</mat-icon>
                                    <div matListItemTitle>
                                        @if(!tab.uboOrder) {
                                        <button [disabled]="tab.someParentHasIncompleteUBO || tab.someChildHasUBO || (tab.businessReportOrder && tab.businessReportOrder.orderStatusTypeID !== 'Complete')" (click)="orderUbo(tab)" mat-flat-button color="accent"
                                            [attr.aria-label]="'hubReportV2.orderUboButton' | transloco" data-testid="order-ubo-button">
                                            <mat-label>{{ 'hubReportV2.orderAnUltimateBeneficialOwnershipReport' | transloco }}</mat-label>
                                        </button>
                                        } @else {
                                        <button mat-flat-button color="accent" (click)="viewOrder(tab.uboOrder.id, false)">{{ 'hubReportV2.goToUltimateBeneficialOwnershipReport' | transloco }}</button>
                                        }
                                    </div>
                                    @if(tab.uboOrder) {
                                    <div matListItemLine class="padding-top-15">
                                        <span>{{ 'common.labels.orderStatus' | transloco }}: <span class="bold">{{ getOrderStatus(tab.uboOrder.orderStatusTypeID) }}</span></span>
                                    </div>
                                    }
                                </mat-list-item>
                            </mat-list>
                        </mat-card-content>
                    </mat-card>
                </mat-tab>
                @if(tab.businessReportOrder && tab.businessReportOrder.orderStatusTypeID === "Complete") {
                <mat-tab class="bottom-level">
                    <ng-template mat-tab-label>
                        <div class="flex-container-vertical-center flex-container-space-between">
                            <span class="flex-item">{{ 'hubReportV2.businessReport' | transloco }}</span>
                            <button class="flex-item menu" (click)="$event.stopPropagation()" mat-icon-button
                                [matMenuTriggerFor]="menu" [attr.aria-label]="'hubReportV2.orderActionsMenu' | transloco">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button (click)="viewOrder(tab.businessReportOrder.id)" mat-menu-item>
                                    <mat-icon color="primary">open_in_new</mat-icon>
                                    <span>{{ 'common.labels.viewOrder' | transloco }}</span>
                                </button>
                                @if(hasRegistryDocument(tab.businessReportOrder)) {
                                <button (click)="openRegistryDocument(tab.businessReportOrder)" mat-menu-item>
                                    <mat-icon color="primary">download</mat-icon>
                                    <span>{{ 'hubReportV2.registryDocument' | transloco }}</span>
                                </button>
                                }
                                @if(hasRegHubDocument(tab.businessReportOrder)) {
                                <button (click)="openRegHubDocument(tab.businessReportOrder)" mat-menu-item>
                                    <mat-icon color="primary">download</mat-icon>
                                    <span>{{ 'hubReportV2.reghubDocument' | transloco }}</span>
                                </button>
                                }
                            </mat-menu>
                        </div>
                    </ng-template>
                    @if (tab.businessReportOrder && tab.businessReportOrder.searchResult?.hasParsedResult) {
                    <lib-business-report-results [order]="tab.businessReportOrder"
                        [results$]="businessReportResults.get(tab.businessReportOrder.id)"></lib-business-report-results>
                    } @else {
                        <span>{{ 'hubReportV2.noParsedResultsAvailable' | transloco }}</span>
                    }
                </mat-tab>
                }
                @if (tab.uboOrder && tab.uboOrder.orderStatusTypeID === 'Complete') {
                <mat-tab class="bottom-level">
                    <ng-template mat-tab-label>
                        <div class="flex-container-vertical-center flex-container-space-between">
                            <span class="flex-item">{{ 'hubReportV2.ultimateBeneficialOwnershipReport' | transloco }}</span>
                            <button class="flex-item menu" (click)="$event.stopPropagation()" mat-icon-button
                                [matMenuTriggerFor]="menu" [attr.aria-label]="'hubReportV2.orderActionsMenu' | transloco">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                               <button (click)="viewOrder(tab.uboOrder.id)" mat-menu-item>
                                    <mat-icon color="primary">open_in_new</mat-icon>
                                    <span>{{ 'common.labels.viewOrder' | transloco }}</span>
                                </button>
                            </mat-menu>
                        </div>
                    </ng-template>
                    @if (tab.uboOrder) {
                    <lib-ubo-order-details-tab-group [order]="tab.uboOrder!" [uiConfiguration]="uboOrderConfiguration" [admin]="isAdmin"></lib-ubo-order-details-tab-group>
                    }
                </mat-tab> 
            }
            </mat-tab-group>
        </mat-tab>
        }
    </mat-tab-group>
</div>
} @else {
<div class="loading-spinner-overlay">
    <mat-spinner></mat-spinner>
</div>
}